import React from 'react';


class VegSection extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            section_img: "",
            section_text: "",
            description: "",
            item_name: "",
            item_content: "",
            itemList: []
        }
    }


    componentWillMount() {
        if (this.props.context !== undefined && this.props.context !== "") {
            if (this.props.context.veg !== undefined && this.props.context.veg !== "") {
                let data = {
                    section_img: "/static/images/img_veg.jpg",
                    section_text: "菜",
                    description: "",
                    item_name: "",
                    item_content: "",
                    itemList: []
                }

                if (this.props.context.veg.section_text !== undefined) {
                    data.section_text = this.props.context.veg.section_text;
                }
                if (this.props.context.veg.description !== undefined) {
                    data.description = this.props.context.veg.description;
                }
                if (this.props.context.veg.section_img !== undefined) {
                    data.section_img = this.props.context.veg.section_img;
                }
                if (this.props.context.veg.item_name !== undefined) {
                    data.item_name = this.props.context.veg.item_name;
                }
                if (this.props.context.veg.item_content !== undefined) {
                    data.item_content = this.props.context.veg.item_content;
                }
                if (this.props.context.veg.itemList !== undefined && this.props.context.veg.itemList.length) {
                    data.itemList = this.props.context.veg.itemList;
                }

                this.setState({
                    section_img: data.section_img,
                    description: data.description,
                    section_text: data.section_text,
                    item_name: data.item_name,
                    item_content: data.item_content,
                    itemList: data.itemList
                })
            }
        }
    }


    render() {

        let itemList;
        if (this.state.itemList.length) {
            itemList = this.state.itemList.map((item, i) => {
                return (
                    <div className="col-md-4 wow fadeInUp" data-wow-delay="0.1s" key={i}>
                        <div className="about-col">
                            <div className="img">
                                <img src={item.item_img} alt="" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                )
            })
        }

        return (
            <div className="vegsection-frame">
                <section>
                        <div className="secondary_banner_wrap">
                            <div>
                                <img src={this.state.section_img} alt="" />
                            </div>
                        </div>
                </section>
                <section>
                    <div className="container">
                        <div className="intro_wrap_1">
                            <div className="intro_title_1">{this.state.section_text}</div>
                            <div className="intro_content_1">{this.state.description}</div>
                            <div className="intro_content_line_1"></div>
                        </div>
                    </div>
                </section>
                <section id="about">
                        <div className="container">

                            <header className="section-header"></header>

                            <div className="info_content_wrap">
                                <div className="info_title">{this.state.item_name}</div>
                                <div className="info_content">{this.state.item_content}</div>
                            </div>

                            <div className="row about-cols">
                                {itemList}
                            </div>

                            <div className="info_line_1"></div>
                            <div className="info_line_2"></div>

                        </div>
                </section>
            </div>
        )
    }
}


export default VegSection


// WEBPACK FOOTER //
// ./src/component/vegSection.js